import React from 'react'

// The whitelisted spacing steps (px). Kept as Numbers; callers may legitimately
// pass either a Number (`size={4}`) or a numeric STRING (`size="4"`, e.g. from
// PortableText block renderers) — both are normalized to a Number below BEFORE
// the whitelist check, so a valid "4" is accepted while a genuinely-invalid 6 /
// "6" still warns. (Comparing a raw string against this Number array with
// indexOf/`includes` is a strict-equality mismatch — that was the source of the
// ~350 "size does not exist: 4/8" console errors on the product pages.)
const sizes = [2, 4, 8, 16, 20, 24, 32, 40, 48, 64, 80, 96, 128, 160, 800]

/**
 * @param {{ className?: string, size: (2|4|8|16|20|24|32|40|48|64|80|96|128|160|800) }} props
 */
function Spacer({ className, size }) {
  const px = Number(size)

  if (!sizes.includes(px)) {
    console.error(`Spacer: The size you have selected does not exist: ${px}. Select one of ${sizes}`)
  }

  return <div className={className} style={{ width: px, height: px }}/>
}

export default Spacer
